import OutlineMessageWarning from 'iq-blueberry/dist/reactIcons/OutlineMessageWarning'

import './style.styl'

const MessageBox = ({ icon = true, children }) => {
  return (
    <div className="message-box">
      {icon && <OutlineMessageWarning />}
      <p className='message-box__text'>{children}</p>
    </div>
  )
}

export default MessageBox